module.exports = __webpack_public_path__ + "media/src/images/voucher_card-84a7819ecdc088f146c690f11f454a57.png";